import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const userStateSlice = createSlice({
    name: 'userstate',
    initialState: {
        ping: ({} as number),
        available: true,
        online: false,
        callpresence: " "
    },
    reducers: {
        setPingValue: (state, action: PayloadAction<number>) => {
            state.ping = action.payload
        },
        setAvailable: (state, action: PayloadAction<boolean>) => {
            state.available = action.payload
        },
        setOnline: (state, action: PayloadAction<boolean>) => {
            state.online = action.payload
        },
        setOnCall: (state, action: PayloadAction<string>) => {
            state.online = true
            state.callpresence = action.payload
        }
    },
})

export const {
    setPingValue
    , setAvailable
    , setOnline
    , setOnCall
} = userStateSlice.actions
export default userStateSlice.reducer


